import router from '@/router'
import { JWTService } from '@/shared/services/jwt'
import ClientFactory from '@/shared/factories/client'
// import { toast } from '@/shared/utils/UIHelper'

const config = {
  baseURL: process.env.APIBaseBPM,
  headers: { 'Content-Type': 'application/json' }
}

const APIClient = ClientFactory.New(config)

APIClient.interceptors.request.use((request) => {
  const token = JWTService.GetToken()

  if (token) {
    let payload = JWTService.GetTokenPayload()
    if (payload) {
      let exp = payload.exp
      if (exp) {
        var today = new Date()
        var secondsToday = Math.round(today.getTime() / 1000)
        if ((exp - secondsToday) <= 0) {
          JWTService.DestroyToken()
          router.replace({ name: 'SignIn' })
          console.log('token expirado!')
          return Promise.reject(new Error('ExpiredToken'))
        }
      }
    }
  }

  /* eslint-disable-next-line */
  // if (token) request.headers.Authorization = `Bearer ${JWTService.GetToken()}`
  if (token) request.headers.Authorization = `${JWTService.GetToken()}`

  return request
}, error => Promise.reject(error))

APIClient.interceptors.response.use(response => response, (error) => {
  if (error === 'ExpiredToken') {
    JWTService.DestroyToken()
    router.replace({ name: 'SignIn' })
  } else if (error.response.status.toString().match(/4\d[13]/)) {
    JWTService.DestroyToken()
    router.replace({ name: 'SignIn' })
  }
  return Promise.reject(error.response)
})

export default APIClient



// WEBPACK FOOTER //
// ./src/shared/http/clients/api.js